var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('h1',{staticClass:"text-xl mb-8 mt-12"},[_vm._v("Sendgrid Activities")]),_c('EmailSengridEvents',{attrs:{"sendgridActivities":_vm.recipientSendgridEvents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }